import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { useDebouncedCallback } from '../../services/customHooks';
import axios from 'axios';
import Notifications from '../../services/notifications';

function SelectDropdown(props) {
  const { id, items, title, value, onChange, disabled } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const showDropdown = useCallback(
    () => setIsOpen(prevIsOpen => !prevIsOpen),
    [setIsOpen],
  );

  const handleClickOutside = useCallback(event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, handleClickOutside]);

  return (
    <div id={id} className="select-dropdown" ref={dropdownRef}>
      <button
        type="button"
        onClick={showDropdown}
        className="select-dropdown-btn"
        disabled={disabled}
      >
        {title}
        <i className={`la ${!isOpen ? 'la-angle-down' : 'la-angle-up'}`} />
      </button>
      {isOpen ? (
        <ul className="select-dropdown-list">
          {items?.map(item => (
            <li
              key={item?.id}
              className={`select-dropdown-list-item ${
                value === item?.id ? 'select-dropdown-list-item-active' : ''
              }`}
              onClick={() => onChange(item?.id)}
              aria-disabled={disabled}
            >
              {item?.text}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

SelectDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SelectDropdown.defaultProps = {
  items: [],
  disabled: false,
};

export default SelectDropdown;
